import { Dispatch } from 'react'

export type CancelFunc = () => void

export const emptyCancel = (): void => {
    // noop
}

export const emptyCancelAsync = (): Promise<void> => {
    return Promise.resolve()
}

export const wrapDispatch = <T>(dispatch: Dispatch<T>): [Dispatch<T>, CancelFunc] => {
    let cancelled = false
    const wrapped = (thing: T): void => {
        if (cancelled) {
            return
        }
        dispatch(thing)
    }
    const cancel = (): void => {
        cancelled = true
    }
    return [wrapped, cancel]
}
